export type SocialInfluencersSettingsStateType = {
  pageSize: number;
  size: number;
  minHits: number;
  customWidgetTitle?: string;
  widgetTitle: string;
  widgetTitleAlignment?: string;
  displayValue: string;
};

export const socialInfluencersDefaultSettings: SocialInfluencersSettingsStateType = {
  pageSize: 20,
  size: 25,
  minHits: 2,
  customWidgetTitle: '',
  widgetTitle: "default",
  widgetTitleAlignment: "left",
  displayValue: "average",
};
